module.exports = __webpack_public_path__ + "static/scale-model-of-lake-harriet-bandshell-park-in-minneapolis-minnesota-a5c7d9befec987abe810ad59a27792fc.png";